import { Close } from "@mui/icons-material";
import { Box, Button, Input, Typography } from "@mui/joy";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { set } from "date-fns";
import React, { useState, useEffect } from "react";
import { DateRangePicker } from "react-date-range";
import { useTranslation } from "react-i18next";

function CustomDateRangePicker({ dates, setDates, onApply }) {
  const [dateRangePickerOpen, setDateRangePickerOpen] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    import("react-date-range/dist/styles.css");
    import("react-date-range/dist/theme/default.css");
  }, []);

  const handleDateChange = (range) => {
    const { startDate, endDate } = range.selection;

    const getLocalDateString = (date) => {
      if (typeof date === "string") {
        return date.split("T")[0];
      }

      // Get the actual local date components (not UTC)
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    };

    let startDateStr = getLocalDateString(startDate);
    let endDateStr = getLocalDateString(endDate);

    setDates({
      startDate: startDateStr,
      endDate: endDateStr,
      key: "selection",
    });
  };

  const handleApplyDateRange = () => {
    onApply();
    setDateRangePickerOpen(false);
  };

  return (
    <>
      <Input
        size="sm"
        sx={{
          minWidth: "200px",
        }}
        placeholder={t("common_date_range")}
        className="search-input"
        value={
          dates.startDate && dates.endDate
            ? `${dates.startDate} - ${dates.endDate}`
            : ""
        }
        readOnly
        onClick={() => {
          setDateRangePickerOpen(true);
        }}
      />
      <Dialog
        maxWidth="lg"
        className="date-range-picker"
        open={dateRangePickerOpen}
        onClose={() => setDateRangePickerOpen(false)}
      >
        <DialogTitle>
          <Box className="p-2 d-flex justify-content-between align-items-center">
            <Typography level="h6">{t("common_date_range")}</Typography>
            <Button
              variant="outlined"
              color="neutral"
              onClick={() => setDateRangePickerOpen(false)}
              className="close-btn"
            >
              <Close />
            </Button>
          </Box>
        </DialogTitle>
        <DialogContent>
          <DateRangePicker
            ranges={[dates]}
            onChange={handleDateChange}
            showSelectionPreview={true}
            moveRangeOnFirstSelection={false}
            months={2}
            direction="horizontal"
            rangeColors={["black"]}
            dateDisplayFormat="yyyy-MM-dd"
            className="custom-date-picker"
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setDates({
                startDate: "",
                endDate: "",
                key: "selection",
              });
              handleApplyDateRange();
            }}
            className="btn btn-danger"
            sx={{ marginRight: "auto", color: "black" }}
          >
            {t("common_reset")}
          </Button>
          <Button
            variant="outlined"
            color="neutral"
            onClick={() => setDateRangePickerOpen(false)}
            className="close-btn"
          >
            {t("common_close")}
          </Button>
          <Button
            className="btn btn-primary"
            variant="contained"
            color="primary"
            onClick={() => handleApplyDateRange()}
          >
            {t("common_apply")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default CustomDateRangePicker;
